// extracted by mini-css-extract-plugin
module.exports = {"item":"page_nav_item-module__item--1kRrI"};